export default __webpack_public_path__ + "static/media/exp-bg.265b8b87.png";